
class HicomProgressBar implements IHicomProgressBar {

	static MAX_ITERATIONS = 50000;
	static BG_SUCCESS = 'bg-success';
	static BG_INFO = 'bg-info';
	static BG_WARNING = 'bg-warning';
	static BG_DANGER = 'bg-danger';

	barId: string;
	bar: HTMLElement;
	$bar: JQuery<HTMLElement>;

	constructor(barId: string) {
		this.barId = barId;
		this.bar = document.getElementById(barId);
		this.$bar = $(`#${barId}`);
	}

	updateBar(currentIteration: number) {
		this.bar.style.width = Math.floor(100 * currentIteration / HicomProgressBar.MAX_ITERATIONS) + '%';
	}

	updatePercentageBarWithBackgrounds(currentIteration: number, redThreshold: number = 34, amberThreshold: number = 67, blueThreshold: number = 95) {
		let barVal = Math.floor(100 * currentIteration / HicomProgressBar.MAX_ITERATIONS);
		this.bar.style.width = barVal + '%';
		this.bar.innerHTML = barVal + '%';

		if (barVal < redThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_DANGER);
		} else if (barVal < amberThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_DANGER + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_WARNING);
		} else if (barVal < blueThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_DANGER)
				.addClass(HicomProgressBar.BG_INFO);
		} else {
			this.$bar.removeClass(HicomProgressBar.BG_DANGER + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_SUCCESS);
		}

	}

	updatePercentageBar(barVal: number): void {
		this.bar.style.width = barVal + '%';
		this.bar.innerHTML = barVal + '%';
	}

	updateFormPercentageBar(validationFields: number, validationErrorFields: number,
		redThreshold: number = 50, amberThreshold: number = 100, blueThreshold: number = 0): void {


		let barVal = Math.floor(100 * (validationFields - validationErrorFields) / validationFields);

		this.bar.style.width = barVal + '%';
		this.bar.innerHTML = barVal + '%';

		if (barVal < redThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_DANGER);
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_DANGER);
		} else if (barVal < amberThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_DANGER + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_WARNING);
		} else if (barVal < blueThreshold) {
			this.$bar.removeClass(HicomProgressBar.BG_SUCCESS + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_DANGER)
				.addClass(HicomProgressBar.BG_INFO);
		} else {
			this.$bar.removeClass(HicomProgressBar.BG_DANGER + ' ' + HicomProgressBar.BG_WARNING + ' ' + HicomProgressBar.BG_INFO)
				.addClass(HicomProgressBar.BG_SUCCESS);
		}

		if (validationFields == validationErrorFields) {
			this.$bar.parent().attr("title", validationFields - validationErrorFields + " fields of " + validationFields + " completed");
			this.bar.title = "";
		}
		else {
			this.$bar.parent().removeAttr('title');
			this.bar.title = validationFields - validationErrorFields + " fields of " + validationFields + " completed";
		}

	}

	setProgressBarFromForm($form) {
		if ($form.find('.progress')) {

			let validationFields = $form.find('.hicom-validation-message:not(".validationHide")').length;
			let validationErrorFields = $form.find('.hicom-validation-message.field-validation-error:not(".validationHide")').length;

			this.updateFormPercentageBar(validationFields, validationErrorFields)

		}
	}

	setProgressBarFromNewForm($form) {
		if ($form.find('.progress')) {

			let validationFields = $form.find('.hicom-validation-message:not(".validationHide")').length;

			this.updateFormPercentageBar(validationFields, validationFields)

		}
	}
}


